export const SurveyResources = {
	es: {
		['survey']: 'Encuesta',
		['survey_desc']: 'Gracias por ayudarnos a mejorar la experiencia de renta. Tus respuestas y comentaios nos ayudan siempre a <1>crear algo mejor</1>.',
		['experience_question']: '¿Cómo te ha parecido la experiencia de rentar tu auto mediante este sistema táctil?',
		['send']: 'Enviar',
	},
	en: {
        ['survey']: 'Survey',
        ['survey_desc']: 'Thank you for helping us improve the rental experience. Your feedback and comments are always helping us <1>create something better</1>.',
        ['experience_question']: 'How was your experience renting your car using this touchscreen system?',
		['send']: 'Send',
	}
}
